import type { Dictionary } from './uk';

type DeepPartial<T> = T extends (infer U)[] ? U[] : T extends object ? { [K in keyof T]?: DeepPartial<T[K]> } : T;
export type PartialDictionary = DeepPartial<Dictionary>;

/**
 * English — scaffold only. Untranslated keys fall back to Ukrainian.
 * Enable in src/i18n/locales.ts once complete.
 */
export const en: PartialDictionary = {
  meta: { localeName: 'English', short: 'EN' },
  common: { next: 'Next', back: 'Back', soon: 'soon' },
  hero: { titleA: 'Decoration that', titleAccent: 'sells', titleB: 'your product' },
};
